import { Browser } from './browser';
import {Duration, Moment, monthsShort} from 'moment';
import * as momentbare from 'moment';
import {extendMoment} from 'moment-range';
import 'moment-duration-format';

const moment = extendMoment(momentbare);

let durationMs = function(x) {return momentbare.duration(x, 'milliseconds')};

export function seleniumSessionStatisticsFromBackendObject(s: any, project: string): SeleniumSessionStatistics {
    return new SeleniumSessionStatistics(s.name.replace(/['"]+/g, ''), project, s.name.replace(/['"]+/g, ''), s.count, s.dates, s.timeouts, durationMs(s.totalDuration), durationMs(s.averageDuration), durationMs(s.minimumDuration),
        durationMs(s.firstQuartile), durationMs(s.medianDuration), durationMs(s.thirdQuartile), durationMs(s.maximumDuration));
}

export function seleniumBrowserStatisticsFromBackendObject(s: any, project: string): SeleniumBrowserStatistics {
    return new SeleniumBrowserStatistics(s.name, project, s.name, s.count, s.dates, s.timeouts, durationMs(s.totalDuration), durationMs(s.averageDuration), durationMs(s.minimumDuration),
        durationMs(s.firstQuartile), durationMs(s.medianDuration), durationMs(s.thirdQuartile), durationMs(s.maximumDuration), s.browser);
}

export function consoleSessionStatisticsFromBackendObject(s: any, project: string): ConsoleSessionStatistics {
    //TODO: remove necessity for this hack in backend
    return new ConsoleSessionStatistics(s.name.replace(/['"]+/g, ''), project, s.name.replace(/['"]+/g, ''), s.count, s.dates, durationMs(s.totalDuration), durationMs(s.averageDuration), durationMs(s.minimumDuration),
        durationMs(s.firstQuartile), durationMs(s.medianDuration), durationMs(s.thirdQuartile), durationMs(s.maximumDuration));
}


export function consoleStatisticsFromBackendObject(s: any, project: string): ConsoleStatistics {
    let platform = s.platform.map ( session => consoleSessionStatisticsFromBackendObject(session, project));
    let device = s.device.map ( session => consoleSessionStatisticsFromBackendObject(session, project));
    let user = s.user.map ( session => consoleSessionStatisticsFromBackendObject(session, project));

    return { platform: platform, device: device, user: user} as ConsoleStatistics;
}

export function seleniumStatisticsFromBackendObject(s: any, project: string): SeleniumStatistics {
    let platform = s.platform.map ( session => seleniumSessionStatisticsFromBackendObject(session, project));
    let device = s.device.map ( session => seleniumSessionStatisticsFromBackendObject(session, project));
    let browser = s.browser.map ( session => seleniumBrowserStatisticsFromBackendObject(session, project));
    let user = s.user.map ( session => seleniumSessionStatisticsFromBackendObject(session, project));

    return {platform: platform, device: device, browser: browser, user: user} as SeleniumStatistics;

}

/**
 *
 * @param toFixed only used if humanreadble = false.
 *      Specifies if the number of secondes should be provided with a fixed amount of decimal places
 */
function formatDuration(d: Duration, humanReadable: boolean, toFixed: boolean = false) {
    if (humanReadable) {
        return d.format("dd:hh:mm:ss", {
            trim: false
        });
    } else {
        let s =  d.asSeconds();
        return toFixed ? s.toFixed(SessionStatistics.precision).toString() : s.toString();
    }
}

export abstract class SessionStatistics {
    constructor(public name: string,
                public platform: string,
                public count: number,
                public dates: string[],
                public totalDuration: Duration,
                public averageDuration: Duration,
                public minimumDuration: Duration,
                public firstQuartile: Duration,
                public medianDuration: Duration,
                public thirdQuartile: Duration,
                public maximumDuration: Duration
    ) {}
    static readonly precision = 1;

    abstract toCSVRow(columnDel, lineDel, humanReadable: boolean, globalPerProject: boolean): string;
}

export class ConsoleSessionStatistics implements SessionStatistics {
    constructor(public name: string,
                public project: string,
                public platform: string,
                public count: number,
                public dates: string[],
                public totalDuration: Duration,
                public averageDuration: Duration,
                public minimumDuration: Duration,
                public firstQuartile: Duration,
                public medianDuration: Duration,
                public thirdQuartile: Duration,
                public maximumDuration: Duration
                ) {}

    public toCSVRow(columnDel, lineDel, humanReadable: boolean, globalPerProject: boolean) {
        let row = this.name + columnDel;
        if (globalPerProject) {
            row += this.project + columnDel;
        }
        row += this.count.toString() + columnDel
            + formatDuration(this.totalDuration, humanReadable) + columnDel
            + formatDuration(this.averageDuration, humanReadable, true) + columnDel
            + formatDuration(this.minimumDuration, humanReadable) + columnDel
            + formatDuration(this.firstQuartile, humanReadable) + columnDel
            + formatDuration(this.medianDuration, humanReadable) + columnDel
            + formatDuration(this.thirdQuartile, humanReadable) + columnDel
            + formatDuration(this.maximumDuration, humanReadable)
            + lineDel;
        return row;
    }
}

export class SeleniumSessionStatistics implements SessionStatistics {
    constructor(public name: string,
                public project: string,
                public platform: string,
                public count: number,
                public dates: string[],
                public timeouts: number,
                public totalDuration: Duration,
                public averageDuration: Duration,
                public minimumDuration: Duration,
                public firstQuartile: Duration,
                public medianDuration: Duration,
                public thirdQuartile: Duration,
                public maximumDuration: Duration
    ) {}

    public toCSVRow(columnDel, lineDel, humanReadable: boolean, globalPerProject: boolean) {
        let row = this.name + columnDel;
        if (globalPerProject) {
            row += this.project + columnDel;
        }
        row += this.count.toString() + columnDel
            + this.timeouts.toString() + columnDel
            + formatDuration(this.totalDuration, humanReadable) + columnDel
            + formatDuration(this.averageDuration, humanReadable, true) + columnDel
            + formatDuration(this.minimumDuration, humanReadable) + columnDel
            + formatDuration(this.firstQuartile, humanReadable) + columnDel
            + formatDuration(this.medianDuration, humanReadable) + columnDel
            + formatDuration(this.thirdQuartile, humanReadable) + columnDel
            + formatDuration(this.maximumDuration, humanReadable)
            + lineDel;
        return row;
    }
}

export class SeleniumBrowserStatistics implements SessionStatistics {
    constructor(public name: string,
                public project: string,
                public platform: string,
                public count: number,
                public dates: string[],
                public timeouts: number,
                public totalDuration: Duration,
                public averageDuration: Duration,
                public minimumDuration: Duration,
                public firstQuartile: Duration,
                public medianDuration: Duration,
                public thirdQuartile: Duration,
                public maximumDuration: Duration,
                public browser: Browser
    ) {}

    public toCSVRow(columnDel, lineDel, humanReadable: boolean, globalPerProject: boolean) {
        let row = this.name + columnDel;
        if (globalPerProject) {
            row += this.project + columnDel;
        }
        row += this.count.toString() + columnDel
            + this.timeouts.toString() + columnDel
            + formatDuration(this.totalDuration, humanReadable) + columnDel
            + formatDuration(this.averageDuration, humanReadable, true) + columnDel
            + formatDuration(this.minimumDuration, humanReadable) + columnDel
            + formatDuration(this.firstQuartile, humanReadable) + columnDel
            + formatDuration(this.medianDuration, humanReadable) + columnDel
            + formatDuration(this.thirdQuartile, humanReadable) + columnDel
            + formatDuration(this.maximumDuration, humanReadable)
            + lineDel;
        return row;
    }
}


export interface SeleniumStatistics {
    platform: SeleniumSessionStatistics[],
    device: SeleniumSessionStatistics[],
    browser: SeleniumBrowserStatistics[],
    user: SeleniumSessionStatistics[]
}


export interface ConsoleStatistics {
    platform: ConsoleSessionStatistics[],
    device: ConsoleSessionStatistics[],
    user: ConsoleSessionStatistics[]
}
